/**
 * AI evaluation trace API endpoints
 */

import { fetchApi } from '../core';
import type { AiEvaluationTraceListResponse, AiTraceQueryParams } from '../types';

function buildTraceQuery(params: AiTraceQueryParams = {}): string {
  const search = new URLSearchParams();
  if (params.tenant_id) search.set('tenant_id', params.tenant_id);
  if (params.submission_id) search.set('submission_id', params.submission_id);
  if (params.kind) search.set('kind', params.kind);
  if (params.outcome) search.set('outcome', params.outcome);
  if (params.model) search.set('model', params.model);
  if (typeof params.after_ms === 'number') search.set('after_ms', String(params.after_ms));
  if (typeof params.before_ms === 'number') search.set('before_ms', String(params.before_ms));
  if (typeof params.page === 'number') search.set('page', String(params.page));
  if (typeof params.limit === 'number') search.set('limit', String(params.limit));
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function listTenantAiTraces(
  params: AiTraceQueryParams = {},
  componentName: string = 'Unknown'
) {
  return fetchApi<AiEvaluationTraceListResponse>(
    `/ai-evaluation-traces${buildTraceQuery(params)}`,
    {},
    componentName
  );
}

export function listPlatformAiTraces(
  params: AiTraceQueryParams = {},
  componentName: string = 'Unknown'
) {
  return fetchApi<AiEvaluationTraceListResponse>(
    `/platform/ai-evaluation-traces${buildTraceQuery(params)}`,
    {},
    componentName
  );
}
